import React, { useLayoutEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { langState, cookieConsentState } from "../recoilAtom";
import { Link } from "gatsby";
import { useLocation } from "@reach/router";
// import "./cookies.scss";

const PermissionBanner = () => {
  const cookieText: any = {
    "pl-PL": {
      h2: "Czy jesteś profesjonalistą z sektora medycznego",
      p: "Na stronie mogą znajdować się informacje przeznaczone wyłącznie dla pracowników ochrony zdrowia, takich jak lekarze, pielęgniarki czy personel pomocniczy. Prosimy o potwierdzenie, że należysz do tej grupy.",
      label: "Potwierdzam, że jestem pracownikiem ochrony zdrowia",
      button1: "Potwierdzam",
      button2: "Nie potwierdzam",
    },
    "en-US": {
      h2: "Are you a healthcare professional?",
      p: "This website may contain information intended only for healthcare professionals, such as doctors, nurses, or support staff. Please confirm that you belong to this group",
      label: "I confirm that I am a healthcare professional",
      button1: "Confirm",
      button2: "I do not confirm",
    },
  };

  const [permissionAccepted, setPermissionAccepted] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [cookieConsent] = useRecoilState(cookieConsentState);
  const [lang, setLang] = useRecoilState(langState);
  const location = useLocation();
  const [isOnProductPage, setIsOnProductPage] = useState(false);

  useLayoutEffect(() => {
    // Check if current path contains "/products"
    const pathname = location?.pathname || "";
    setIsOnProductPage(pathname.includes("/products"));
  }, [location?.pathname]);

  // Disable scrolling when modal is shown
  useLayoutEffect(() => {
    if (
      isOnProductPage &&
      !permissionAccepted &&
      cookieConsent &&
      typeof window !== "undefined"
    ) {
      // Save current scroll position and disable scrolling
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
      document.body.style.top = `-${scrollY}px`;

      return () => {
        // Restore scrolling and scroll position
        document.body.style.position = "";
        document.body.style.width = "";
        document.body.style.top = "";
        window.scrollTo(0, scrollY);
      };
    }
  }, [isOnProductPage, permissionAccepted, cookieConsent]);

  useLayoutEffect(() => {
    document.cookie.indexOf("CookieBy=MedinicePermissionCookie") !== -1
      ? setPermissionAccepted(true)
      : setPermissionAccepted(false);
  }, []);

  const answerPermission = () => {
    document.cookie =
      "CookieBy=MedinicePermissionCookie; SameSite=None; Secure; max-age=" +
      60 * 60 * 24 * 60;
    setPermissionAccepted(true);
  };

  return (
    <>
      {isOnProductPage && !permissionAccepted && cookieConsent && (
        <div
          id="permission-modal"
          className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center overflow-hidden"
        >
          <div className="flex flex-col bg-white lg:p-6 rounded-lg shadow-lg gap-1 lg:max-w-[560px] z-50 p-4 max-w-[calc(100vw-48px)] m-4 fade-in-from-top">
            <h2 className="text-lg lg:text-xl font-bold">
              {cookieText[lang].h2}
            </h2>
            <p className="text-sm lg:text-base">{cookieText[lang].p}</p>
            <div className="my-1">
              <input
                type="checkbox"
                id="cookie-consent"
                checked={isChecked}
                onChange={() => setIsChecked(!isChecked)}
              />
              <label htmlFor="cookie-consent" className="ml-2">
                {cookieText[lang].label}
              </label>
            </div>
            <div className="flex gap-4 pt-2">
              <button
                className={`${
                  !isChecked
                    ? "opacity-50 cursor-not-allowed text-slate-200 border-slate-200 bg-slate-600"
                    : "text-blue-600 border-blue-600 bg-white"
                } font-bold text-base px-4 py-2 rounded-full w-max transition-all duration-700 ease-in border-2 border-solid`}
                onClick={() => (!isChecked ? null : answerPermission())}
                disabled={!isChecked}
              >
                {cookieText[lang].button1}
              </button>
              <Link
                to="/patients"
                className="font-bold text-base px-4 py-2 rounded-full text-white w-max transition-all duration-700 ease-in bg-blue-600 border-2 border-solid border-blue-600"
              >
                {cookieText[lang].button2}
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PermissionBanner;
